export type PaywallRedirectTarget = 'contact' | 'portal' | 'checkout'

export function resolvePaywallRedirect(params: {
  isOrgaAdmin: boolean
  accountType: string
  hasStripeCustomer: boolean
}): PaywallRedirectTarget {
  const { isOrgaAdmin, accountType, hasStripeCustomer } = params
  if (!isOrgaAdmin) return 'contact'
  if (accountType === 'ENTERPRISE' || accountType === 'FREE') return 'contact'
  if (hasStripeCustomer) return 'portal'
  return 'checkout'
}
